module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/food/bottle-1-e4b85b7d09bab13b2cd005de66dfabf2.svg";